import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter, useLocation } from "react-router-dom";
import * as gtag from './gtag';

// Component to listen for route changes and send pageview to Google Analytics
function AnalyticsListener({ children }) {
  const location = useLocation();
  React.useEffect(() => {
    const pagePath = window.location.pathname + window.location.search;
    gtag.pageview(pagePath);
  }, [location]);
  return children;
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AnalyticsListener>
          <App />
          <ToastContainer />
        </AnalyticsListener>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);